import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBkQsRbu8Je2dpy4I4pr_7EjQ42ZaeqN0w",
  authDomain: "steriahouse.firebaseapp.com",
  projectId: "steriahouse",
  storageBucket: "steriahouse.firebasestorage.app",
  messagingSenderId: "749989114839",
  appId: "1:749989114839:web:3d45f4c956962fe0429192"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
